import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

export class RemoveRewardMetadata extends CommandBase {
    uid: string;

    constructor(uid: string) {
        super();
        this.uid = uid;
    }

    execute(state: RemoteConstantsModel): boolean {
        if (state.rewards === undefined) {
            return false;
        }

        const index = state.rewards.findIndex(a => a.uid === this.uid);
        if (index < 0) {
            return false;
        }

        state.rewards.splice(index, 1);
        return true;
    }
}